import { useTranslation } from 'react-i18next'

import data from '../../data/landing/product-catalog'

function Featured() {
  const { t } = useTranslation()

  return (
    <section className="tc-featured-style6">
      <div className="container">
        <div className="section-title mb-50 text-center">
          <h2 className="js-splittext-lines marcellus">{t('featured.title')}</h2>
        </div>
        <div className="tab-content wow fadeInUp slow" data-wow-delay="0.2s" id="pills-tabContent">
          <div className="tab-pane fade show active" id="pills-rings">
            <div className="products-slider">
              <div className="swiper-wrapper">
                {data.Rings.map((item, i) => (
                  <div key={i} className="swiper-slide">
                    <div className="product-card">
                      <div className="img">
                        <img src={item.img} alt="" className="img-contain" />
                      </div>
                      <div className="info text-center mt-30">
                        <h4 className="fsz-30 fw-400 mb-15">{item.title}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
          <div className="tab-pane fade" id="pills-other">
            <div className="products-slider">
              <div className="swiper-wrapper">
                {data.Other.map((item, i) => (
                  <div key={i} className="swiper-slide">
                    <div className="product-card">
                      <div className="img">
                        <img src={item.img} alt="" className="img-contain" />
                      </div>
                      <div className="info text-center mt-30">
                        <h4 className="fsz-30 fw-400 mb-15">{item.title}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Featured
